__turbopack_context__.v({
  "pagemaintitle": "tnpsc-demo-class-video-module__KKVC1W__pagemaintitle",
  "sectiontitle": "tnpsc-demo-class-video-module__KKVC1W__sectiontitle",
  "tablinks": "tnpsc-demo-class-video-module__KKVC1W__tablinks",
});
